import { gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"

import {
  CreatePaymentMethodStripeAchViaPlaidInput,
  CreatePaymentMethodStripeAchViaPlaidPayload,
} from "@oysterhr/schema"

const PAYMENTS_COMPANY_CREATE_ACH_PAYMENT_METHOD_VIA_PLAID_MUTATION = gql`
  mutation PaymentsCompanyCreatePaymentMethodStripeAchViaPlaid(
    $ownerId: ID!
    $token: String!
    $account: JSON!
    $accounts: JSON!
  ) {
    createPaymentMethodStripeAchViaPlaid(
      input: { ownerId: $ownerId, token: $token, account: $account, accounts: $accounts }
    ) {
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
          state
          accountNumber
          routingNumber
        }
      }
      errors
    }
  }
`

export default () => {
  const [createPaymentMethod, { loading }] = useMutation<
    CreatePaymentMethodStripeAchViaPlaidPayload,
    CreatePaymentMethodStripeAchViaPlaidInput
  >(PAYMENTS_COMPANY_CREATE_ACH_PAYMENT_METHOD_VIA_PLAID_MUTATION, {
    analyticsEventName: "stripe_ach_payment_method_created",
  })

  return {
    createPaymentMethod,
    loading,
  }
}
